import React from 'react';
import { connect } from 'react-redux';
import { Translate } from 'react-localize-redux';
import { withLocalize } from 'react-localize-redux';
import { bindActionCreators } from 'redux';
import { Circles } from '../../common/loadingComponent';
import { reportActions } from '../../../store/reportStore';
import { isNullOrUndefined } from '../../../store/storeFunctions';
import Money from '../../common/moneyComponent';
import Number from '../../common/numberComponent';
import Paging from '../../common/pagingComponent';
import LienGroup from './lienGroup';
import ExcelExportButton from '../../common/excelExportButton';
import OldStyleTableWithHistory from '../../common/oldStyleTableWithHistory';

class LiensSection extends React.Component {
    state = { page: 1 };

    get section() {
        return this.props.sections.find(o => o.id === this.props.sectionId).subsections.find(q => q.id === this.props.subsectionId);
    }

    get pageSize() {
        const limits = this.props.getSectionLimits(this.props.reportType, this.props.subsectionId);
        return this.section.isLimited ? limits.pageSize.limited : limits.pageSize.unlimited;
    }

    componentDidMount = () => {
        this.props.loadIfExpanded(this.props.sectionId);
    }

    render() {
        const { data, loadingMoreData, isLimited } = this.section;
        const summary = this.props.getParentSection([this.props.sectionId, this.props.subsectionId]).data;
        const subsectionSummary = summary.find(item => item.id === this.props.subsectionData.subjectType);
        return isNullOrUndefined(data) ? null : this.renderLiens(data, subsectionSummary, loadingMoreData, isLimited);
    }

    renderLiens = (data, summary, isLoading, isLimited) => {
        const max = data.length > this.pageSize * this.state.page ? this.pageSize * this.state.page : data.length;

        if (!isLimited && isLoading)
            return <Circles />;

        const liens = data.slice(0, max);
        const active = liens.filter(f => f.parentLien.active);
        const historical = liens.filter(f => !f.parentLien.active);

        return (
            <>
                <OldStyleTableWithHistory stripped noMargin tableColumns={4} classNames={{ "summary-pre-table": true }}
                    resolveExpanded={this.props.resolveExpanded}
                    actualData={summary.summaries.filter(summaryItem => summaryItem.activeTotalCount > 0)}
                    actualRow={(r) => <tr key={r.currencyId}>
                        <td style={{ width: "15%" }}><Translate id="Report.Liens.SummaryTotalCount" />:</td>
                        <td><Number value={r.activeTotalCount} fractionDigits={0} /></td>
                        <td style={{ width: "14%" }}><Translate id="Report.Liens.SummaryTotalPrice" /> ({r.currencyId}):</td>
                        <td style={{ width: "37%" }}><Money value={r.activeTotalPrice} fractionDigits={2} /></td>
                    </tr>}
                />
                <OldStyleTableWithHistory tableColumns={8} stripped classNames={{ "with-ellipsed-column": true }}
                    resolveExpanded={this.props.resolveExpanded}
                    head={() => <thead>
                        <tr>
                            <th style={{ width: "3em" }} />
                            <th style={{ width: "14%" }}><Translate id="Report.Liens.FileMark" /></th>
                            <th>
                                <Translate id={function (subjectType) {
                                    switch (subjectType) {
                                        case "CR": return "Report.Liens.Debtor";
                                        case "DE": return "Report.Liens.Creditor";
                                        default: return "";
                                    }
                                }(this.props.subsectionData.subjectType)} />
                            </th>
                            <th style={{ width: "11%" }}><Translate id="Report.Liens.Type" /></th>
                            <th style={{ width: "14%", textAlign: "right" }}><Translate id="Report.Liens.Price" /></th>
                            <th style={{ width: "6em" }}><Translate id="Report.Liens.Currency" /></th>
                            <th style={{ width: "12%", textAlign: "right" }}><Translate id="Report.Liens.Date" /></th>
                            <th style={{ width: "5em" }} />
                        </tr>
                    </thead>}
                    actualData={active}
                    actualRow={(r) => <LienGroup key={r.parentLien.lienId}
                        subjectType={this.props.subsectionData.subjectType}
                        subjectTypeName={this.props.subsectionData.subjectTypeName}
                        group={r}
                    />}
                    historyData={historical}
                    historyRow={(r) => <LienGroup key={r.parentLien.lienId}
                        subjectType={this.props.subsectionData.subjectType}
                        subjectTypeName={this.props.subsectionData.subjectTypeName}
                        group={r}
                    />}
                />
                {isLimited && summary.totalCount > max && this.renderMoreLinks(summary.totalCount, isLoading)}
                {!isLimited && summary.totalCount > this.pageSize && <div style={{ marginTop: "2em" }}>
                    <Paging
                        justify="center"
                        selectedPage={this.state.page}
                        totalPages={Math.ceil(summary.totalCount / this.pageSize)}
                        setPage={page => this.onChangePage(page)}
                    />
                </div>}
                <ExcelExportButton link="liens" entityId={this.props.id} report={this.props.reportType} additionalParams={{ type: this.props.subsectionData.subjectType }} />
            </>
        );
    }

    renderMoreLinks = (totalCount, isLoading) => {
        return (
            <>
                <div>
                    {this.state.page === 1 && <span className="link-functional" onClick={() => this.getMore()}>
                        <Translate id="Report.Common.More" />
                    </span>}
                    {this.state.page === 2 && <a className="link-functional" target="_blank"
                        href={this.props.getUnlimitedSectionLink(this.props.reportType, this.props.id, this.props.sectionId)}
                    >
                        <Translate id="Report.Common.ShowAll" />&nbsp;({totalCount})
                    </a>}
                </div>
                {isLoading && <div style={{ width: "100%" }} className="search-progress searching"></div>}
            </>
        )
    }

    getMore = () => {
        this.props.fetchMoreData(
            [this.props.sectionId, this.props.subsectionId],
            { count: this.pageSize, offset: this.pageSize, report: this.props.reportType, type: this.props.subsectionData.subjectType },
            null, this.concatData, () => this.setState({ page: 2 })
        );
    }

    onChangePage = (page) => {
        this.props.fetchMoreData(
            [this.props.sectionId, this.props.subsectionId],
            { count: this.pageSize, offset: (page - 1) * this.pageSize, report: this.props.reportType, type: this.props.subsectionData.subjectType },
            null, this.replaceData, () => this.setState({ page: page })
        );
    }

    concatData = (_hint, oldData, newData) => oldData.concat(newData);
    replaceData = (_hint, _oldData, data) => data;
}

export default withLocalize(connect(
    state => state.report,
    dispatch => bindActionCreators(reportActions, dispatch)
)(LiensSection));